const skillsArray = [
    { name: "Git", imageURL: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/skill-logos/git-logo.png" },
    {
        name: "HTML5",
        imageURL: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/skill-logos/html5-logo.png",
    },
    { name: "CSS3", imageURL: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/skill-logos/css3-logo.png" },
    {
        name: "Javascript",
        imageURL: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/skill-logos/javascript-logo.png",
    },
    { name: "SCSS", imageURL: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/skill-logos/scss-logo.png" },
    { name: "BEM", imageURL: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/skill-logos/bem-logo.png" },
    {
        name: "React",
        imageURL: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/skill-logos/react-logo.png",
    },
    { name: "Java", imageURL: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/skill-logos/java-logo.png" },
    {
        name: "Spring Boot",
        imageURL: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/skill-logos/springboot-logo.png",
    },
    {
        name: "C#",
        imageURL: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/skill-logos/csharp-logo.png"
    }
];



export default skillsArray;
